import { render, staticRenderFns } from "./groupOrderEditForm.vue?vue&type=template&id=5e06c276&"
import script from "./groupOrderEditForm.vue?vue&type=script&lang=js&"
export * from "./groupOrderEditForm.vue?vue&type=script&lang=js&"
import style0 from "./groupOrderEditForm.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports